import type { ReactElement } from "react";
import ReactMarkdown, { type Components } from "react-markdown";

import type { SolomonTermsDescriptor } from "@/content/terms/solomonMainAppTerms";

export type { SolomonTermsDescriptor } from "@/content/terms/solomonMainAppTerms";

const components: Components = {
    h1: ({ children }) => (
        <h1 className="text-base font-medium text-foreground-base">
            {children}
        </h1>
    ),
    h2: ({ children }) => (
        <h2 className="mt-4 mb-2 text-sm font-medium text-foreground-base">
            {children}
        </h2>
    ),
    p: ({ children }) => (
        <p className="mb-4 text-sm leading-relaxed text-foreground-neutral last:mb-0">
            {children}
        </p>
    ),
    ul: ({ children }) => (
        <ul className="mb-4 list-disc space-y-1 pl-5 text-sm leading-relaxed text-foreground-neutral">
            {children}
        </ul>
    ),
    ol: ({ children }) => (
        <ol className="mb-4 list-decimal space-y-1 pl-5 text-sm leading-relaxed text-foreground-neutral">
            {children}
        </ol>
    ),
    strong: ({ children }) => (
        <strong className="font-semibold text-foreground-base">
            {children}
        </strong>
    ),
    em: ({ children }) => (
        <em className="text-foreground-neutral">{children}</em>
    ),
    a: ({ children, href }) => (
        <a
            className="text-accent underline underline-offset-2"
            href={href}
            rel="noreferrer"
            target="_blank"
        >
            {children}
        </a>
    )
};

export function SolomonTermsDocument({
    terms
}: {
    terms: SolomonTermsDescriptor;
}): ReactElement {
    return (
        <div
            data-terms-document-key={terms.documentKey}
            data-terms-version={terms.version}
            data-terms-digest={terms.contentDigest}
        >
            <ReactMarkdown components={components} skipHtml>
                {terms.text}
            </ReactMarkdown>
        </div>
    );
}
